<template>
    <!--begin::Authentication - New password -->
    <div
        class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
        <!--begin::Content-->
        <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            <!--begin::Logo-->
            <a href="#" class="mb-5">
                <img alt="Logo" :src="'/admin/images/logo_mostra.png'"
                     class="h-100px"/>
            </a>
            <!--end::Logo-->
            <!--begin::Wrapper-->
            <div class="w-lg-550px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
                <!--begin::Form-->
                <form
                    @submit.prevent="form.post(this.route('password.update'))"
                    class="form w-100"
                    novalidate="novalidate"
                    id="kt_new_password_form"
                >
                    <!--begin::Heading-->
                    <div class="text-center mb-10">
                        <!--begin::Title-->
                        <h1 class="text-dark mb-3">Definir nova senha</h1>
                        <!--end::Title-->
                        <!--begin::Link-->
                        <div class="text-gray-400 fw-bold fs-4">Já mudou sua senha?
                            <Link
                                :href="this.route('login')"
                                class="link-primary fw-bolder">
                                Faça o login
                            </Link>
                        </div>
                        <!--end::Link-->
                    </div>
                    <!--begin::Heading-->

                    <!--begin::Input group-->
                    <div class="mb-10 fv-row" data-kt-password-meter="true">

                        <!--begin::Wrapper-->
                        <div class="mb-1">
                            <!--begin::Label-->
                            <label class="form-label fw-bolder text-dark fs-6">Informe sua nova senha</label>
                            <!--end::Label-->
                            <!--begin::Input wrapper-->
                            <div class="position-relative mb-3">
                                <input
                                    v-model="form.password"
                                    class="form-control form-control-lg form-control-solid"
                                    type="password"
                                    autocomplete="off"
                                    placeholder="Sua senha"
                                    @blur="form.clearErrors('password')"
                                    :class="{'is-invalid': form.errors.password}"
                                />
                                <span class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                                      data-kt-password-meter-control="visibility">
                                    <i class="bi bi-eye-slash fs-2"></i>
                                    <i class="bi bi-eye fs-2 d-none"></i>
                                </span>
                            </div>
                            <!--begin::Meter-->
                            <div class="d-flex align-items-center mb-3" data-kt-password-meter-control="highlight">
                                <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
                                <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
                                <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
                                <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px"></div>
                            </div>
                            <!--end::Meter-->
                            <!--end::Input wrapper-->
                            <message-validation v-if="form.errors.password" :message="form.errors.password"/>
                        </div>
                        <!--end::Wrapper-->
                        <!--begin::Hint-->
                        <div class="text-muted">
                            Para uma senha mais segura, use 6 ou mais caracteres misturando letras, números e &amp;
                            símbolos.
                        </div>
                        <!--end::Hint-->
                    </div>

                    <!--end::Input group=-->
                    <!--begin::Input group=-->
                    <div class="fv-row mb-10">
                        <label class="form-label fw-bolder text-dark fs-6">Digite a senha novamente</label>
                        <input
                            v-model="form.password_confirmation"
                            class="form-control form-control-lg form-control-solid"
                            type="password"
                            autocomplete="off"
                            @blur="form.clearErrors('password_confirmation')"
                            :class="{'is-invalid': form.errors.password_confirmation}"
                        />
                        <message-validation v-if="form.errors.password_confirmation" :message="form.errors.password_confirmation"/>
                    </div>
                    <!--end::Input group=-->

                    <!--begin::Actions-->
                    <div class="text-center">
                        <button
                            type="submit"
                            id="kt_sign_up_submit"
                            class="btn btn-lg btn-primary"
                            :class="{disabled: form.processing}"
                            :disabled="form.processing"
                            :data-kt-indicator='form.processing ? "on" : "off"'
                        >
                            <span class="indicator-label">Entrar</span>
                            <span class="indicator-progress">Aguarde...
                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                        </button>
                        <!--end::Submit button-->
                    </div>
                    <!--end::Actions-->
                </form>
                <!--end::Form-->
            </div>
            <!--end::Wrapper-->
        </div>
        <!--end::Content-->

        <footer-auth />
    </div>
    <!--end::Authentication - New password-->
</template>

<script>
import {Link, useForm} from '@inertiajs/inertia-vue3'
import MessageValidation from "@forms/MessageValidation";
import FooterAuth from "./FooterAuth";

export default {
    props: {
        email: {
            type: Object
        },
        token: {
            type: String
        },
    },
    components: {
        FooterAuth,
        Link,
        MessageValidation
    },

    setup(props) {
        const form = useForm({
            email: props.email,
            password: null,
            password_confirmation: null,
            token: props.token,
        });

        return {form}
    },
}
</script>
